import { createElement, forwardRef, useRef } from "react";
import ColorfulButton from '../colorful-button';
import './index.scss';
import classNames from "classnames";
const ColorfulCard = forwardRef(({ title, children, iconTlt, iconBtn, hideHeader, hideFooter, headerSplit, footerSplit, btnText, onClick, ...otherProps }, ref) => {
    const prefixCls = `au-card`;
    const classString = classNames(prefixCls, {
        [`${prefixCls}-header-split`]: headerSplit,
        [`${prefixCls}-footer-split`]: footerSplit,
    });
    const _otherProps = otherProps || {};
    const nativeCardRef = useRef(null);
    return (createElement("div", { className: classString, ..._otherProps, ref: ref || nativeCardRef },
        !hideHeader &&
            createElement("div", { className: 'au-card-header' },
                iconTlt && createElement("label", { className: 'au-card-flag' }, iconTlt),
                createElement("h3", { className: 'au-card-title' }, title || '卡片标题'),
                iconBtn && createElement("label", { className: 'au-card-oper' }, iconBtn)),
        createElement("div", { className: 'au-card-content' }, children),
        !hideFooter &&
            createElement("div", { className: 'au-card-footer' },
                createElement(ColorfulButton, { type: 'primary', shape: 'square', onClick: (e) => onClick(e), text: btnText || '确认' }))));
});
ColorfulCard.displayName = 'ColorfulCard';
export default ColorfulCard;
